import React, { useEffect, useRef, useState } from 'react'
import { MainTitle } from '../components/MainTitle'
import { IoLocationSharp } from "react-icons/io5";
import { BsFillTelephoneFill } from "react-icons/bs";
import { IoIosMail } from "react-icons/io";
import "../css/ContactUs.css"
import * as imagesdata from '../imagesdata'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { motion } from 'framer-motion';

gsap.registerPlugin(ScrollTrigger);
const ContactUs = () => {
    const imgRef = useRef(null);
    const [mapWidth, setMapWidth] = useState(0)
    const [fontSize, setFontSize] = useState(0);
    useEffect(() => {
        gsap.to(imgRef.current, {
            y: 0,
            ease: "none",
            scrollTrigger: {
                trigger: imgRef.current,
                start: "top bottom", // Animasyonun başladığı nokta
                end: "bottom top", // Animasyonun bittiği nokta
                scrub: true, // Scroll ile bağlantılı olarak animasyon sürekli yapılır
            },
        });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth
            const newMapWidth = Math.max(270, Math.min(1200, width * 0.8));
            const newFontSize = Math.max(15, Math.min(25, (width / 25)));
            setMapWidth(newMapWidth)
            setFontSize(newFontSize)
        };

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div className='contact-us-container'>
            <MainTitle headerImage={imagesdata.HeaderContactUs}/>
            <div className='main-text-bold-header' style={{ fontSize: `${fontSize - 2}px` }}>
                <h1>
                    Bizimle <span className='main-title-dark-text-outline'>İletişime </span> Geçin
                </h1>
            </div>
            <div className='main-text-header'>
                <h4>
                Ürünlerimizi satın almak için bizi arayabilir ya da mağazamızı ziyaret edebilirsiniz. İletişim bilgilerimiz 
                aşağıda yer almaktadır. Konum bilgilerimizi de Google Haritalar üzerinden ulaşabilirsiniz.
                </h4>
            </div>
            <div className='contact-us-card-container'>
                <motion.div className='contact-us-card'
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5, delay: 0 * 0.1 }}
                    style={{ display: "flex", justifyContent: "center" }}
                >
                    <div className='contact-us-card-icon-header'>
                        <div className='contact-us-card-icon'>
                            <IoLocationSharp size={50} />
                        </div>
                    </div>
                    <div className='contact-us-card-content'>
                        <h2>Adres</h2>
                        <p>ATLAS VADİ KAMPÜSÜ 2020. <br />
                           ANADOLU CAD. NO:40 <br />
                           KAĞITHANE/İSTANBUL</p>
                    </div>
                </motion.div>

                <motion.div className='contact-us-card'
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5, delay: 1 * 0.1 }}
                    style={{ display: "flex", justifyContent: "center" }}
                >
                    <div className='contact-us-card-icon-header'>
                        <div className='contact-us-card-icon'>
                            <BsFillTelephoneFill size={18} />
                        </div>
                    </div>
                    <div className='contact-us-card-content'>
                        <h2>Telefon</h2>
                        <p><a href='tel:+905522483700'>+90 552 248 3700</a></p>
                    </div>
                </motion.div>

                <motion.div className='contact-us-card'
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5, delay: 2 * 0.1 }}
                    style={{ display: "flex", justifyContent: "center" }}
                >
                    <div className='contact-us-card-icon-header'>
                        <div className='contact-us-card-icon'>
                            <IoIosMail size={22} />
                        </div>
                    </div>
                    <div className='contact-us-card-content'>
                        <h2>Email</h2>
                        <p><a href='mailto:info@trafluxx.com'>info@trafluxx.com</a></p>
                    </div>
                </motion.div>
            </div>
            <hr className='contact-us-hr' />
            <div className='contact-us-map-container'>
                <div className='contact-us-map-image'>
                    <div className='contact-us-map-image-overlay' />
                    <div className='contact-us-map-image-content' style={{ fontSize: `${fontSize}px` }}>
                        <h1><span className='contact-us-light-text-outline'>Konum</span> Bilgilerimiz</h1>
                    </div>
                    <img ref={imgRef} src={imagesdata.Location} />
                </div>
                <div className='contact-us-map'>
                    <div className='contact-us-map-border' style={{ width: `${mapWidth + 25}px` }} />
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d384854.5296235747!2d28.979655!3d41.097925!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab72b74ed5dd5%3A0x771c8cf508276827!2s%C4%B0stanbul%20Atlas%20%C3%9Cniversitesi!5e0!3m2!1str!2str!4v1737456934812!5m2!1str!2str" style={{ width: `${mapWidth}px`, height: "400px", zIndex: "2" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div >
    )
}

export default ContactUs